import type { BaseKeyFunction } from "../../../../../../lib/types/baseKeyFunction";

export type KeyCommunitiesStatsTotalsProps = {
  endDate?: Date;
  id: number;
  startDate?: Date;
};

export const keyCommunitiesStatsTotals: BaseKeyFunction<
  KeyCommunitiesStatsTotalsProps
> = ({ endDate, id, startDate }) => [
  "communities-stats-totals",
  id?.toString(),
  startDate?.toString(),
  endDate?.toString(),
];
